/**
 * Centro Comercial — hub de capacidades comerciales existentes.
 * No duplica motores: cada card navega al módulo real.
 */

export const CENTRO_COMERCIAL_MODULES = [
  {
    id: 'lista-expres',
    label: 'Lista Exprés',
    description: 'Elegí productos y creá material comercial en minutos.',
    path: '/productos/precios?expres=1',
    status: 'active',
    permission: 'listas_precios.ver',
    featured: true
  },
  {
    id: 'flyers-material',
    label: 'Flyers y material',
    description:
      'Creá piezas listas para WhatsApp, redes o impresión usando tus productos reales.',
    path: '/centro-comercial/flyer',
    status: 'active',
    permission: 'listas_precios.ver',
    featured: true
  },
  {
    id: 'gestion-listas',
    label: 'Listas de precios',
    description: 'Creá, administrá y compartí listas profesionales de productos.',
    path: '/productos/precios',
    status: 'active',
    permission: 'listas_precios.ver'
  },
  {
    id: 'promociones',
    label: 'Promociones',
    description: 'Descuentos y vigencias promocionales sobre tu catálogo.',
    path: '/promociones',
    status: 'active',
    permission: 'promociones.ver'
  },
  {
    id: 'combos',
    label: 'Combos',
    description: 'Paquetes comerciales con precio conjunto.',
    path: '/combos',
    status: 'active',
    permission: 'combos.ver'
  },
  {
    id: 'catalogo-online',
    label: 'Catálogo Online',
    description: 'Publicación digital del catálogo comercial.',
    path: '/centro-comercial/catalogo-online',
    status: 'planned',
    sprint: 'D'
  }
];
